import { render, staticRenderFns } from "./AuthSet2faCode.vue?vue&type=template&id=1ce1ca22&scoped=true"
import script from "./AuthSet2faCode.vue?vue&type=script&lang=js"
export * from "./AuthSet2faCode.vue?vue&type=script&lang=js"
import style0 from "./AuthSet2faCode.vue?vue&type=style&index=0&id=1ce1ca22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce1ca22",
  null
  
)

export default component.exports